import { checkFactory as factory } from '@lovejunk/core'
import { Loading } from 'components'

export default factory({ Loading })
